(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbContentSearchService', ['$http', '$q', 'gettextCatalog', 'pxUriPathService', ContentSearchService]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbContentTypesService
	 * 
	 * @description
	 * Exposes methods for retrieving content types that belong to a content
	 * type group.
	 */
	function ContentSearchService($http, $q, gettextCatalog, pxUriPathService) {
		
		return {
			/**
			 * @ngdoc method
			 * @name smbContentTypesService.getContentTypes
			 * @methodOf smb-app.smbContentTypesService
			 * @kind function
			 * 
			 * @description
			 * Gets all content types the belong to a content type group
			 * 
			 * @param {Number} groupId Id of the content type group
			 * 
			 * @returns {Deferred} A promise that will resolve to a collection of content types
			 */
			getDocuments: getDocuments,

			getContentTypeGroupSearchResults: getContentTypeGroupSearchResults
		};

		function getDocuments(groupId, typeId, tagValues) {
			if (!groupId) {
				return $q.reject(new Error(gettextCatalog.getString('Missing required document type group id')));
			}

			var uri = pxUriPathService.resolvePath('/documenttypes/' + typeId + '/search');
			return $http.post(uri, tagValues)
				.then(function (response) {
					return response.data.Embedded.Documents;
				});
		}

		function getContentTypeGroupSearchResults(groupId, tagValues) {
			if (!groupId) {
				return $q.reject(new Error(gettextCatalog.getString('Missing required document type group id')));
			}

			var uri = pxUriPathService.resolvePath('/documenttypegroups/' + groupId + '/search');
			return $http.post(uri, tagValues)
				.then(function (response) {
					return response.data.Embedded.Documents;
				});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/contentSearchService.js
// module id = 140
// module chunks = 1